export default __webpack_public_path__ + "static/media/setting.8cc52d1b.svg";